<div class="card mb-3">
  <div class="card-header px-3 px-md-4">
    <div class="row align-items-center">
      <!-- Bulk actions -->
      <app-list-bulk-actions
        [selected]="selected"
        [totalItems]="totalItems"
        (unselect)="onUnselectAll()"
        [disabled]="!selected.length"
        [disabledIfAll]="true"
        *ngIf="incoming"
      >
        <a
          class="dropdown-item"
          *ngIf="selected.length"
          href
          (click)="onDownloadSEPA(); (false)"
        >
          <i class="mr-1 fe fe-credit-card fe-fw"></i>
          {{ 'SEPA payment orders' | translate }}</a
        >
      </app-list-bulk-actions>

      <div class="col">
        <h4 class="card-header-title">
          {{ title }} <span>({{ totalItems }})</span>
        </h4>
      </div>

      <div class="col-auto">
        <app-list-filters-btn
          (toggle)="showFilters = $event"
        ></app-list-filters-btn>
      </div>
    </div>
  </div>

  <app-list-filters
    class="card-body border-bottom py-3"
    (refresh)="get($event)"
    [form]="filters"
    *ngIf="showFilters"
    [dateFields]="['dateDue', 'date']"
    [hideAutoLimit]="true"
  ></app-list-filters>

  <ng-container *ngIf="documents$ | async as documents">
    <div class="table-responsive d-none d-md-block">
      <table class="table table-hover card-table list-table">
        <thead>
          <tr>
            <th *ngIf="incoming" class="pr-0">
              <app-list-bulk-checkbox
                [page]="page"
                [length]="totalItemsOnPage"
                (check)="onToggleSelectAll()"
                [selectedOnPage]="selectedOnPage"
              ></app-list-bulk-checkbox>
            </th>
            <th>{{ 'Type' | translate }}</th>
            <th>
              {{ 'Number' | translate }}
            </th>
            <th>
              <span>{{ 'Date due' | translate }}</span>
            </th>
            <th>
              {{ 'Partner' | translate }}
            </th>
            <th class="text-center">
              {{ 'Status' | translate }}
            </th>
            <th class="text-right">
              <span>{{ 'active-documents.table.total-owed' | translate }}</span>
            </th>
            <th class="text-right">
              <!-- Actions -->
              <a
                style="cursor: pointer"
                (click)="get(true); (false)"
                ngbTooltip="{{ 'tooltip.refresh' | translate }}"
              >
                <i class="far fa-sync-alt text-muted"></i>
              </a>
            </th>
          </tr>
        </thead>

        <tbody>
          <tr
            app-active-document
            class="{{ 'type-indicator-' + document.type }}"
            [class.type-indicator]="true"
            *ngFor="let document of documents"
            [activeOrg]="activeOrg"
            [currentLang]="currentLang"
            [document]="document"
            [incoming]="incoming"
            [isChecked]="isChecked(document)"
            (check)="onToggleSelected($event)"
            (addPayment)="onAddPayment($event)"
            (cancel)="onCancel($event)"
            (delete)="onDelete($event)"
          ></tr>

          <tr
            app-table-empty-state
            *ngIf="!documents.length"
            content="{{ 'No documents' | translate }}"
            [cta]="cta"
            [ctaRouterLink]="[
              '../../documents/',
              !incoming ? 'o' : 'i',
              'add',
              'invoice'
            ]"
          ></tr>
        </tbody>
      </table>
    </div>

    <div class="d-block d-md-none card-body py-3 pl-3 pr-0">
      <app-active-document-card
        *ngFor="let document of documents; let idx = index"
        [document]="document"
        [activeOrg]="activeOrg"
        [incoming]="incoming"
        [isChecked]="isChecked(document)"
        [currentLang]="currentLang"
        (addPayment)="onAddPayment($event)"
        (cancel)="onCancel($event)"
        (check)="onToggleSelected($event)"
        (delete)="onDelete($event)"
        [last]="idx === documents.length - 1"
      ></app-active-document-card>
    </div>
  </ng-container>

  <!-- Loading state -->
  <app-content-loader [loading]="loading.data"></app-content-loader>
</div>

<div class="row mt-3">
  <div class="col">
    <ngb-pagination
      class="pagination d-flex justify-content-center justify-content-md-end"
      *ngIf="totalItems"
      [pageSize]="filters.controls.limit.value"
      [collectionSize]="totalItems"
      [disabled]="!totalItems || totalItems <= filters.controls.limit.value"
      [(page)]="page"
      (pageChange)="onPageChanged($event)"
    ></ngb-pagination>
  </div>
  <div class="col-auto pl-0 d-none d-md-inline-block">
    <app-pagination-page-select
      (pageChange)="onPageChanged($event)"
      *ngIf="totalItems"
      [page]="page"
      [totalItems]="totalItems"
      [pageSize]="filters.controls.limit.value"
    ></app-pagination-page-select>
  </div>
</div>
